import { computed } from 'vue';
import type { City } from '@/core/components/form-elements/CitySelector.vue';
import { useJobFiltersStore } from '@/modules/content-blocks/stores/jobFilters.store';
import { debounce } from '@future-harry/nxt-vue-library';
import { storeToRefs } from 'pinia';

export const useJobFilters = () => {
   const store = useJobFiltersStore();
   const { filters } = storeToRefs(store);

   const searchQuery = computed<string>({
      get: () => store.searchQuery,
      set: (value: string) =>
         debounce(async () => {
            store.setSearchQuery(value);
         }, 500),
   });

   const searchCity = computed<City | null>({
      get: () => store.searchCity,
      set: (city: City | null) =>
         debounce(async () => {
            store.setSearchCity(city);
         }, 500),
   });

   const jobTypes = computed<{ value: number }[]>({
      get: () => store.jobTypes,
      set: (values: { value: number }[]) => store.setJobTypes(values),
   });

   const workSchedules = computed<number[]>({
      get: () => store.workSchedules,
      set: (values: number[]) => store.setWorkSchedules(values),
   });

   const cities = computed<any>({
      get: () => store.cities,
      set: (values: any) => store.setCities(values),
   });

   return {
      filters,
      jobTypes,
      cities,
      workSchedules,
      searchQuery,
      searchCity,
   };
};
